import { gql } from '@anyx/common-graphql';

export const SAVE_CUSTOMER_TAGS = gql(/* GraphQL */ `
  mutation SaveCustomerTags($input: SetCustomerTagsRequest!) {
    SetChatCustomerTags(input: $input) {
      name
    }
  }
`);

export const UPDATE_AI_AUTO_REPLY_SETTING = gql(/* GraphQL */ `
  mutation UpdateAIAutoReplySetting($input: UpdateAIAutoReplySettingInput!) {
    updateAIAutoReplySetting(input: $input) {
      ok
    }
  }
`);

export const CREATE_CUSTOMER_NOTE = gql(/* GraphQL */ `
  mutation CustomerNoteV3Create($input: CustomerNoteV3CreateRequest!) {
    CustomerNoteV3Create(input: $input) {
      ...CustomerNoteFields
    }
  }
`);

export const UPDATE_CUSTOMER_NOTE = gql(/* GraphQL */ `
  mutation CustomerNoteV3Update($input: CustomerNoteV3UpdateRequest!) {
    CustomerNoteV3Update(input: $input) {
      id
      text
      updatedAt
    }
  }
`);

export const DELETE_CUSTOMER_NOTE = gql(/* GraphQL */ `
  mutation CustomerNoteV3Delete($input: CustomerNoteV3DeleteRequest!) {
    CustomerNoteV3Delete(input: $input) {
      ok
    }
  }
`);
